import cx from 'classnames';
import TriStateProgressBar from '../TriStateProgressBar';

import styles from './ProgressBar.scss';
/* eslint-disable react/prop-types */ // TODO: add props

const ProgressBar = ({ value, total, className }) => {
  const nullCount = total - value;

  return (
    <TriStateProgressBar
      positiveCount={value}
      positiveCountClassName={cx(styles.valueProgressIndicator, className)}
      nullCount={nullCount}
      nullCountClassName={styles.noProgressIndicator}
      negativeCount={0}
      order={['positive', 'null']}
    />
  );
};

export default ProgressBar;
